<template>
  <BasicModal :title="'カスタムカラム一括変更'" :isShowModal="isShowModal" :canCancel="true" :width="'32%'" @cancel="cancel">
    <div class="wrapper">
      <div class="content">
        カラム名：
        <select class="select is-fullwidth" v-model="selectedColumn">
          <option v-for="column in customColumns" :key="column.pk" :value="column">{{ column.name }}</option>
        </select>
      </div>
      <div class="content">
        変更内容：
        <!-- カラム未選択 -->
        <template v-if="selectedColumn == null">
          <input type="text" class="input is-fullwidth" disabled>
        </template>
        <!-- プルダウン -->
        <template v-else-if="selectedColumn.is_pulldown_flg == 1">
          <select class="select is-fullwidth" v-model="newValue">
            <option value="">選択してください</option>
            <option v-for="option in getOptionsForColumn(selectedColumn.pk)" :key="option.id" :value="option.name">{{
              option.name }}</option>
          </select>
        </template>
        <!-- 日付 -->
        <template v-else-if="selectedColumn.type_for_custom_column == 3">
          <input type="date" class="input is-fullwidth" v-model="newValue" />
        </template>
        <!-- 複数行テキスト -->
        <template v-else-if="selectedColumn.is_multiline">
          <div class="cell-content-wrapper">
            <textarea class="textarea is-fullwidth" v-model="newValue"></textarea>
          </div>
        </template>
        <!-- 1行テキスト -->
        <template v-else>
          <input class="input is-fullwidth" v-model="newValue" />
        </template>
      </div>
      <div class="content">
        変更対象：
        <div class="seeker-list disp-scroll">
          <div v-for="seeker in seekers" :key="seeker.id">
            <span>{{ seeker.name }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="footer-box">
      <button class="button is-light" @click="cancel">キャンセル</button>
      <button class="button is-primary" @click="updateCustomColumn(); cancel();" :disabled="!isValid">
        変更する
      </button>
    </div>
  </BasicModal>
</template>

<script>
import BasicModal from '@/components/Modals/BasicModal'

export default {
  name: 'ModalChangeCustomColumn',
  components: {
    BasicModal,
  },
  props: {
    isShowModal: {
      type: Boolean,
      default: false,
    },
    seekers: {
      type: Array,
      default: () => [],
    },
    companyColumnSetting: {
      type: Array,
      default: () => [],
    },
    pulldownOptionsByColumnId: {
      type: Object,
      default: () => { },
    },
  },
  data() {
    return {
      selectedColumn: null,
      newValue: "",
    }
  },
  computed: {
    customColumns() {
      return this.companyColumnSetting.filter(column => column.template_type == 0)
    },
    isValid() {
      if (this.selectedColumn == null) return false
      if (!this.newValue) return false
      return true
    }
  },
  watch: {
    selectedColumn() {
      this.newValue = ""
    }
  },
  methods: {
    getOptionsForColumn(columnId) {
      const options = this.pulldownOptionsByColumnId[columnId] || [];
      if (options.length === 0) {
        console.warn(`No options found for column ${columnId}`);
      }
      return options;
    },
    updateCustomColumn() {
      const updateData = []
      for (let seeker of this.seekers) {
        const customColumn = seeker.custom_column.find(col => col.column == this.selectedColumn.pk)
        console.log(customColumn)
        if (customColumn) {
          // 更新
          const copiedCustomColumn = { ...customColumn }
          copiedCustomColumn.content = this.newValue
          copiedCustomColumn.id = seeker.id
          updateData.push(copiedCustomColumn)
        }
        else {
          // 新規作成
          let newCustomColumn = null
          if (this.selectedColumn.is_pulldown_flg == 1 || this.selectedColumn.type_for_custom_column == 3) {
            // プルダウンまたは日付
            newCustomColumn = {
              name: this.selectedColumn.name,
              type: 1,
              content: this.newValue,
              select_list: '',
              column: this.selectedColumn.pk,
              id: seeker.id,
              pk: -1
            };
          }
          else {
            // テキスト
            newCustomColumn = {
              name: this.selectedColumn.name,
              type: 0,
              content: this.newValue,
              select_list: '',
              column: this.selectedColumn.pk,
              id: seeker.id,
              pk: -1
            }
          }
          updateData.push(newCustomColumn)
        }
      }
      this.$emit('buldUpdateOrCreateCustomColumn', updateData)
    },
    cancel() {
      this.$emit('cancel')
    },
  },
}
</script>

<style lang="scss" scoped>
.wrapper {
  margin-left: 24px;
  margin-right: 24px;
}

.content {
  margin-top: 12px;
  margin-bottom: 12px;
}

.seeker-list {
  padding-left: 16px;
  max-height: 200px;
  overflow-y: scroll;
}


.footer-box {
  width: 100%;
  height: 64px;
  border-top: solid thin #ccc;
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-wrap: wrap;
  overflow: auto;

  button {
    width: 47%;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Manage/ModalChangeCustomColumn.vue